export const NAVIGATE_TO_POWER_APPS         =       "NAVIGATE_TO_POWER_APPS"
export const CLOUD_NOTES_LISTING            =       "CLOUD_NOTES_LISTING"
export const DOCUMENTS_LIST                 =       "DOCUMENTS_LIST"